module.exports = __webpack_public_path__ + "static/media/dashed-line.8360774f.png";